import template from './add_time_rules.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class AddTimeRulesViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.employees = ko.observableArray();
		this.select_individual = ko.observable(false);
		this.start_time = ko.observable();
		this.end_time = ko.observable();
		this.grace_period =ko.observable();

		this.include_lunch = ko.observable(false);
		this.shift_worker = ko.observable(false);
		this.lunch_duration = ko.observable();
		this.target_work_hours_pw = ko.observable();
		this.target_work_hours_pm = ko.observable();
		this.view_only = ko.observable(false);

		this.current_employee_id = ko.observable();
		this.selected_employee = ko.observable();

		this.select_all_weekdays = ko.observable(false);
		this.weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];

		this.normal_workdays = ko.observableArray(['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']);
		this.selected_workdays = ko.observableArray([]);
		this.today = ko.observable(Utils.toJSONDateString(new Date()));
		this.holidays = ko.observableArray([]);
		this.event_dates = ko.observableArray([]);
		this.shift_date_picker = null;
		this.selected_dates = ko.observableArray([]);
		this.night_shift_hours = ko.observable();
		this.day_shift_hours = ko.observable();

		this.selected_workdays.subscribe((newValue) => {
			// Check if all weekdays (Mon-Fri) are selected
			let all_weekdays_selected = this.weekdays.every(day =>
				newValue.includes(day)
			);         
			if (this.select_all_weekdays() !== all_weekdays_selected) {
				this.select_all_weekdays(all_weekdays_selected);
			}
		});
		
		this.selected_employee.subscribe((newValue) => {
			if (newValue != null)
				this.current_employee_id(newValue.employee_id);
			else
				this.current_employee_id(null);
		});

		this.select_all_weekdays.subscribe((newValue) => {
			if (newValue) {
				// Select only Monday through Friday
				this.selected_workdays(this.weekdays.slice());
			} else {
				// Deselect all workdays
				this.selected_workdays([]);
			}
		});

		this.target_work_hours_pw.subscribe((newValue) => {
			// Calculate target hours per month when user manually enters target hours per week
			if (newValue) {
				this.target_work_hours_pm(newValue * 4);
			}
		});

		this.end_time.subscribe((value) => {
			let start = new Date(`2024-01-01T${this.start_time()}`);
			let end = new Date(`2024-01-01T${value}`);
		
			// Calculate time difference in hours
			let hoursDiff = (end - start) / (1000 * 60 * 60);
		
			// Adjust for the number of selected workdays
			let selectedWorkdaysCount = this.selected_workdays().length || 5;
			let week_hour_target = hoursDiff * selectedWorkdaysCount;
		
			let month_hour_target = week_hour_target * 4;
			
			this.target_work_hours_pw(week_hour_target);
			this.target_work_hours_pm(month_hour_target);
		});
		
		this.selected_workdays.subscribe(() => {
			// Recalculate work hours when workdays change
			if (this.start_time() && this.end_time()) {
				this.end_time.valueHasMutated();
			}
		});

		this.shift_worker.subscribe((newValue) => {
			if (newValue)
				this.initialize_datepicker();
			else {
				if (this.shift_date_picker) {
					this.shift_date_picker.destroy();
					this.shift_date_picker = null;
				}
			}
		});
		
		this.selected_dates.subscribe((newDates) => {
			if (newDates && Array.isArray(newDates)) {
				this.updateDateList(newDates);
			}
		});
	}


	formatDateString(date)
	{
		const d = new Date(date);
		const year = d.getFullYear();
		const month = String(d.getMonth() + 1).padStart(2, '0');
		const day = String(d.getDate()).padStart(2, '0');
		return `${year}-${month}-${day}`;
	}

	updateDateList(dates) {
		let dateListContainer = document.getElementById('selected-dates-list');
		if (!dateListContainer) return;

		dateListContainer.innerHTML = '';

		let datesArray = Array.isArray(dates) ? dates : [dates];
		let sortedDates = datesArray.sort((a, b) => new Date(a) - new Date(b));

		sortedDates.forEach(date => {
			let formattedDate = this.formatDateString(date);
			let listItem = document.createElement('li');
			listItem.className = 'date-list-item';
			let dateText = document.createElement('span');
			dateText.textContent = formattedDate;       
			let removeBtn = document.createElement('button');
			removeBtn.className = 'remove-date-btn';
			removeBtn.innerHTML = '×';
			removeBtn.onclick = (e) => {
				e.preventDefault();
				e.stopPropagation();
				this.removeDate(formattedDate);
				listItem.remove();
			};            
			listItem.appendChild(dateText);
			listItem.appendChild(removeBtn);
			dateListContainer.appendChild(listItem);
		});
	}

	removeDate(dateToRemove)
	{
		this.selected_dates.remove(dateToRemove);      
		if (this.shift_date_picker) {
			console.log(this.shift_date_picker);
			const currentDates = this.shift_date_picker.selectedDates.filter(date =>
				this.formatDateString(date) !== dateToRemove
			);
			this.shift_date_picker.setDate(currentDates, false);
		}
	}

	close()
	{
		this.dialog.close();
	}

	async save_entry()
	{

		if (this.shift_worker())
			this.selected_workdays([])
			
			

		let params = {
			employee_id: this.current_employee_id(),
			department_id: this.dialog.bindings.department_id,
			company_id: this.dialog.bindings.company_id,
			include_lunch: this.include_lunch(),
			lunch_duration: this.lunch_duration(),
			target_hours_per_week: this.target_work_hours_pw(),
			target_hours_per_month: this.target_work_hours_pm(),
			normal_workdays: this.selected_workdays(),
			grace_period: this.grace_period(),
			normal_working_hours: {
				start_time: this.start_time(),
				end_time: this.end_time(),
			},
			shift_worker: this.shift_worker(),
			night_shift_hours: this.night_shift_hours(),
			day_shift_hours: this.day_shift_hours(),
			selected_dates: this.shift_worker() ?
				(typeof this.selected_dates() === 'string' ?
					this.selected_dates().split(',') : this.selected_dates()) :null
		};

		try {
			let response = await fetch('/time_management/save_time_rule', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(params),
			});

			let result = await response.json();

			if (result.status === 'OK')
			{
				Grape.alerts.alert({type: 'success', title: 'Success', message: tr('Time rule saved successfully')});
				this.close();
			}
			else
				Grape.alerts.alert({type: 'error', title: 'Error', message: tr('Error saving time rule: ' + result.message)});
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({type: 'error', title: 'Error', message: tr('Error saving time rule. Please try again.')});
		}
	}

	initialize_datepicker() {
		if (this.shift_date_picker)
			this.shift_date_picker.destroy();
        
		let calendar_config = {
			mode: 'multiple',
			dateFormat: 'Y-m-d',
			allowInput: true,
			minDate: 'today',
			defaultDate: this.selected_dates(),
			conjunction: ',',
			onDayCreate: (dObj, dStr, fp, dayElem) => {
				const date_string = this.formatDateString(dayElem.dateObj);

				const holiday = this.holidays().find(h => h.holiday_date === date_string);
				if (holiday) {
					dayElem.classList.add('holiday');
					dayElem.style.backgroundColor = holiday.hexcolor || '#FFE4E1';
					dayElem.setAttribute('title', holiday.description);
				}

				if (date_string === this.today()) {
					dayElem.classList.add('today');
				}
			},
			onChange: (selectedDates, dateStr, instance) => {
				if (!selectedDates || selectedDates.length === 0) {
					this.selected_dates([]);
					return;
				}

				const jsonDates = selectedDates.map(date => this.formatDateString(date));
				const sortedDates = jsonDates.sort((a, b) => new Date(a) - new Date(b));
				this.selected_dates(sortedDates);
			},
			appendTo: document.body,
			static: true
		};

		this.shift_date_picker = flatpickr('#datepicker_shift', calendar_config);

		if (this.selected_dates().length > 0) {
			const sortedDates = this.selected_dates().sort((a, b) => new Date(a) - new Date(b));
			this.shift_date_picker.setDate(sortedDates, false);
			this.updateDateList(sortedDates);
		}
	}

	async load_holidays() {
		try {
			const holiday_res = await Grape.fetches.postJSON('/leave/get_holidays', {});
            
			if (holiday_res?.get_holidays) {
				this.holidays(holiday_res.get_holidays);
                
				// Reinitialize datepicker if it exists to reflect the new holiday data
				if (this.shift_worker() && this.shift_date_picker) {
					this.initializeShiftDatepicker();
				}
			} else {
				this.holidays.removeAll();
			}
		} catch (error) {
			console.error('Error loading holidays:', error);
			Grape.alerts.alert({
				type: 'error',
				title: 'Error',
				message: tr('Failed to load holiday data')
			});
		}
	}
}

class AddTimeRulesPage
{
	constructor (bindings)
	{
		this.bindings = bindings.row ? bindings.row : bindings;
		this.viewModel = new AddTimeRulesViewModel(this);
	}

	async init()
	{
		await this.load_holidays();
		await this.load_calendar_colors();
		console.log('the bindings', this.bindings);
		if (this.bindings.employee_id)
		{
			let [start, end] = this.bindings.normal_working_hours.split(' - ');
			
			this.viewModel.lunch_duration(this.bindings.lunch_duration);
			this.viewModel.target_work_hours_pw(this.bindings.target_hours_per_week);
			this.viewModel.target_work_hours_pm(this.bindings.target_hours_per_month);
			this.viewModel.start_time(start);
			this.viewModel.end_time(end);
			this.viewModel.select_individual(true);

			//split this.bindings.employee into first_name and last_name
			let first_name = this.bindings.employee.split(' ')[0];
			let last_name = this.bindings.employee.split(' ')[1];

			this.viewModel.selected_employee({
				employee_id: this.bindings.employee_id,
				firstname: first_name,
				surname: last_name,
				id_number: ''
			});
			this.viewModel.current_employee_id(this.bindings.employee_id);
		}
		else
			this.viewModel.current_employee_id(null);

		// Set shift worker status and dates
		if (this.bindings.shift_worker !== undefined) {
			this.viewModel.shift_worker(this.bindings.shift_worker);
			if (this.bindings.shift_worker && this.bindings.shift_dates) {
				// Handle shift dates whether they're in string or array format
				let dates = Array.isArray(this.bindings.shift_dates) 
					? this.bindings.shift_dates 
					: this.bindings.shift_dates.split(',').map(d => d.trim());
				this.viewModel.selected_dates(dates);
				
				// Initialize datepicker after setting dates
				setTimeout(() => {
					this.viewModel.initialize_datepicker();
				}, 0);
			}
		}

		// Set normal workdays
		if (this.bindings.normal_work_day) {
			let workdays = this.bindings.normal_work_day;
			// Handle workdays whether they're in string format {Monday,Tuesday} or array format
			if (typeof workdays === 'string') {
				workdays = workdays
					.replace(/[{}]/g, '')  // Remove curly braces
					.split(',')            // Split into array
					.map(day => day.trim()); // Trim whitespace
			}
			this.viewModel.selected_workdays(workdays);
		}

		if (this.bindings.lunch_duration)
			this.viewModel.include_lunch(true);
		else
			this.viewModel.include_lunch(false);
	}

	async load_calendar_colors()
	{
		let res = await Grape.fetches.postJSON('/general/get_leave_color_combinations', {});
		generateCSScolorCombinations(res);
	}

	async load_holidays()
	{
		let holiday_res = await Grape.fetches.postJSON('/leave/get_holidays', {});

	

		if (holiday_res?.get_holidays) {
			this.viewModel.holidays(holiday_res.get_holidays);
			
		}
			
		else
			this.viewModel.holidays.removeAll();
	}
}

export default {
	name: 'AddTimeRules',
	dialog_class: AddTimeRulesPage,
	template: template,
	template_filename: 'translation/dialogs/add_time_rules',
	provider: 'ps'
};